import {
  AnalysisGraphQL,
  GetAnalysisPipelineStep,
  isParameterOptimizationStepType,
} from 'analysis-tool/AnalysisTypes';
import {checkCanInsertStep} from 'analysis-tool/EditStepHelpers';
import getDataFrameFilterOptions from 'analysis-tool/filters/GetDataFrameFilterOptions';
import isAnalysisReadOnly from 'analysis-tool/isAnalysisReadOnly';
import {PILL_DISABLED_DUE_TO_DOWNSTREAM_FLAG_ROWS} from 'analysis-tool/ui/charting/TransformPill';
import {DataReference} from 'analysis-tool/ui/main-view/MainViewTypes';
import {DataFrameHeaderMenuOptions} from 'data-frames/header-menu/DataFrameHeaderMenuOptions';
import {DataFrameReadOnlyInfo} from 'data-frames/header-menu/DataFrameReadOnlyInfo';
import hasDownstreamFlagRowsStep from 'pipelines/hasDownstreamFlagRowsStep';

import {getHideColumnOptions} from './GetDataFrameHideColumnOptions';
import {getRenameColumnOptions} from './GetDataFrameRenameColumnOptions';
import {getRetypeColumnOptions} from './GetDataFrameRetypeColumnOptions';

export function getReadOnlyInfo(
  analysis: AnalysisGraphQL,
  step: GetAnalysisPipelineStep,
  inputDataFrameId?: string
): DataFrameReadOnlyInfo {
  if (isAnalysisReadOnly(analysis)) {
    return {isReadOnly: true};
  }

  if (hasDownstreamFlagRowsStep(analysis, step)) {
    return {
      isReadOnly: true,
      allUpdatesDisabledMessage: PILL_DISABLED_DUE_TO_DOWNSTREAM_FLAG_ROWS,
    };
  }

  if (isParameterOptimizationStepType(step.definition.stepType)) {
    return {
      isReadOnly: true,
    };
  }

  const {canEdit, message} = checkCanInsertStep(analysis, step.id, 'table', inputDataFrameId);

  return canEdit ? {isReadOnly: false} : {isReadOnly: false, allUpdatesDisabledMessage: message};
}

export function getDataFrameHeaderMenuOptions(
  analysis: AnalysisGraphQL,
  step: GetAnalysisPipelineStep,
  inputDataReference: DataReference,
  inputDataFrameId?: string,
  outputDataReferences?: Array<DataReference>
): DataFrameHeaderMenuOptions {
  return {
    readOnlyInfo: getReadOnlyInfo(analysis, step, inputDataFrameId),
    filterOptions: getDataFrameFilterOptions(
      analysis,
      step,
      inputDataReference,
      inputDataFrameId,
      outputDataReferences
    ),
    hideColumnOptions: getHideColumnOptions(
      analysis,
      step,
      inputDataReference,
      inputDataFrameId,
      outputDataReferences
    ),
    renameColumnOptions: getRenameColumnOptions(
      analysis,
      step,
      inputDataReference,
      inputDataFrameId,
      outputDataReferences
    ),
    retypeColumnOptions: getRetypeColumnOptions(
      analysis,
      step,
      inputDataReference,
      inputDataFrameId,
      outputDataReferences
    ),
  };
}
